import { ApplicationError } from './applicationError.mjs';

const regExpCache = new Map();

// Return a case-insensitive RegExp for word.
function getRegExpFor(word) {
    if (!regExpCache.has(word)) {
        const re = new RegExp(
            '(?<!\\p{L})' + RegExp.escape(word) + '(?!\\p{L})', 'iu');
        regExpCache.set(word, re);
    }
    return regExpCache.get(word);
}

const translations = {
    Sofia    : { EN : 'Sofia',    BG : 'София'    },
    Plovdiv  : { EN : 'Plovdiv',  BG : 'Пловдив'  },
    Burgas   : { EN : 'Burgas',   BG : 'Бургас'   },
    Varna    : { EN : 'Varna',    BG : 'Варна'    },
    Ruse     : { EN : 'Ruse',     BG : 'Русе'     },
    Bulgaria : { EN : 'Bulgaria', BG : 'България' },
};

const translate = (name, lang) => {
    if (!translations.hasOwnProperty(name)) {
        throw new ApplicationError(`no translations for "${name}"`);
    }
    return translations[name][lang];
};

export default function normalizeQuery(query, city, country) {
    let parts = [];

    if (query) {
        // Delete city and country in English and Bulgarian.
        for (const word of [city, country]) {
            for (const lang of ['EN', 'BG']) {
                query = query.replace(getRegExpFor(translate(word, lang)), '');
            }
        }

        // Separate digit-letter combinations by a single space,
        // e.g., convert house numbers like '15A' to '15 A'.
        // https://photon.komoot.io/ works better this way.
        query = query.replace(/(?<=\p{N})(?=\p{L})/u, ' ');

        // Delete leftover, now superfluous commas.
        query = query.replace(/^(?:\s*,\s*)+/, '');   // at start
        query = query.replace(/(?:\s*,\s*)+$/, '');   // at end
        query = query.replace(/(?:\s*,)+/,     ',');  // in between

        // Reduce sequences of 2 or more spaces to a single space.
        query = query.replace(/\s{2,}/, ' ');

        // Remove leading and trailing spaces.
        query = query.trim();

        parts.push(query.toLowerCase());
    }

    parts.push(city.toLowerCase());
    parts.push(country.toLowerCase());

    return parts.join(', ');
}
